import {
  authenticatedDelete,
  authenticatedGet,
  authenticatedPost,
  handleApiResponse
} from '../utils/apiClient';

const BASE_PATH = '/api/mcp-tokens';
const DEFAULT_APP = 'mcp_google_map_reviews';

export const mcpTokenService = {
  async listTokens(app = DEFAULT_APP) {
    const query = app ? `?app=${encodeURIComponent(app)}` : '';
    return handleApiResponse(authenticatedGet(`${BASE_PATH}${query}`));
  },

  async createToken({ app = DEFAULT_APP, role = 'exporter', expiresInDays = 180 } = {}) {
    return handleApiResponse(
      authenticatedPost(BASE_PATH, {
        app,
        role,
        expires_in_days: expiresInDays
      })
    );
  },

  async revokeToken(tokenId) {
    return handleApiResponse(authenticatedDelete(`${BASE_PATH}/${encodeURIComponent(tokenId)}`));
  }
};

export const getGoogleMapReviewsMcpUrl = () => (
  process.env.REACT_APP_GOOGLE_MAP_REVIEWS_MCP_URL
    || 'https://mcp-google-map-reviews-gw3b7kt7xq-as.a.run.app/mcp'
);

export const getCmiInsightsMcpUrl = () => (
  process.env.REACT_APP_CMI_INSIGHTS_MCP_URL
    || 'https://mcp-cmi-insights-gw3b7kt7xq-as.a.run.app/mcp'
);

export const getRosettaMcpUrl = () => (
  process.env.REACT_APP_ROSETTA_MCP_URL
    || 'https://rosetta-mcp-gw3b7kt7xq-as.a.run.app/mcp'
);

export const getYoutubeRetailAnalyzerMcpUrl = () => (
  process.env.REACT_APP_YOUTUBE_RETAIL_ANALYZER_MCP_URL
    || '<configure REACT_APP_YOUTUBE_RETAIL_ANALYZER_MCP_URL>'
);

export const canAccessYoutubeRetailAnalyzer = (user, menuCommands = []) => (
  user?.global_role === 'super_admin'
  || user?.role === 'super_admin'
  || menuCommands.includes('youtube-retail-analyzer')
);

export const canAccessRosettaMcp = (user, menuCommands = []) => (
  user?.global_role === 'super_admin'
  || user?.role === 'super_admin'
  || menuCommands.includes('rosetta-mcp')
);
